export const Avatar = ({
  initials = "?",
  color = "#E5E7EB",
  size = 44,
  className = "",
  onClick,
}) => (
  <div
    onClick={onClick}
    className={
      "flex items-center justify-center font-bold text-gray-900 flex-shrink-0 " +
      className +
      (onClick ? " cursor-pointer hover:opacity-80 active:scale-95 transition-all" : "")
    }
    style={{
      width: size,
      height: size,
      borderRadius: "50%",
      background: color,
      fontSize: size * 0.38,
      letterSpacing: "-0.02em",
    }}
  >
    {initials}
  </div>
);

export default Avatar;
